'use client';

import { ChangeEvent, CSSProperties } from 'react';

import {
  DesktopMemoPopover,
  MobileMemoBottomSheet,
} from '@/features/ArticleDetail';
import { useDeviceCheck } from '@/shared/hooks';

interface HighlightMemoProps {
  style?: CSSProperties;
  memo: string;
  onMemoChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  isMemoOpen: boolean;
  onMemoClose: () => void;
  onMemoSubmit: () => void;
}

const HighlightMemo = ({
  style,
  memo,
  onMemoChange,
  isMemoOpen,
  onMemoClose,
  onMemoSubmit,
}: HighlightMemoProps) => {
  const { isDesktop } = useDeviceCheck();

  if (isDesktop) {
    return (
      <span
        className="absolute -bottom-2 left-1/2 z-10 h-fit min-h-[74px] min-w-[460px] shrink-0 -translate-x-1/2 translate-y-full font-normal"
        style={{
          ...style,
        }}
      >
        <DesktopMemoPopover
          value={memo}
          onChange={onMemoChange}
          onClose={onMemoClose}
          onSubmit={onMemoSubmit}
          placeholder="메모를 입력해 주세요."
        />
      </span>
    );
  }

  return (
    <MobileMemoBottomSheet
      isOpen={isMemoOpen}
      setOpen={onMemoClose}
      value={memo}
      onChange={onMemoChange}
      onClose={onMemoClose}
      onSubmit={onMemoSubmit}
      placeholder="메모를 입력해 주세요."
    />
  );
};

export default HighlightMemo;
